import * as ko from "knockout";
import entityBase from "entityBase";
import { CustomObservables } from "app/custom-observables";

export class solution_keyword extends entityBase {
  solution_id: KnockoutObservable<string>;
  keyword: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>; // keyword type

  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;

  constructor(item?: any) {
    super();
    this.solution_id = ko.observable(item?.solution_id);
    this.keyword = ko.observable(item?.keyword);
    this.user_def1 = ko.observable(item?.user_def1);
    this.created_by = ko.observable(item?.created_by);
    this.created_dttm = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
  }
}
